exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.estilo_dos_columnas[data-v-0ead1301] {\n  width: 50%;\n  margin-left: 5px;\n  margin-top: 5px;\n}\n.estilo_tres_columnas[data-v-0ead1301] {\n  width: 33%;\n  padding-right: 10px;\n  padding-top: 15px;\n}\n", ""]);

// exports
